import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../../../authConfig';
import MicrosoftLoginButton from './microsoft-login-button';

type LoginFormValues = {
    email: string;
    password: string;
};

const LoginForm = () => {
    const { instance } = useMsal();

    const handleLogin = () => {
        instance
            .loginPopup({
                ...loginRequest,
                redirectUri: `${window.location.origin}/login`,
                prompt: 'create',
            })
            .catch((e) => {
                console.error(e);
            });
    };

    return <MicrosoftLoginButton buttonTheme="dark" onClick={handleLogin} />;
};

export default LoginForm;
